import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './index.less';
import { useTranslation } from 'react-i18next';
import { WarningOutlined } from '@ant-design/icons';

const InfoBox = ({
  icon,
  title,
  renderTitle,
  description,
  translate,
  action,
  className,
  textClassName,
  hideIcon,
  translateValues
}) => {
  const { t } = useTranslation(translate);

  return (
    <div className={classNames(styles.boxContainer, 'flex items-center mt-1')}>
      <div className={classNames('flex flex-row italic text-xs', className)}>
        {!hideIcon && <div className={classNames('mr-0.5 flex self-start mt-1 justify-center')}>
          {icon || <WarningOutlined height={14}/>}
        </div>}
        <div>
          {(title || renderTitle) &&
          <div
            className={classNames({ 'mb-1': description }, { 'ml-1': icon && !hideIcon }, textClassName)}>
            {renderTitle ? renderTitle(title, translateValues) : t(title, { ...translateValues })}
            {action && <span className="ml-1">{action}</span>}
          </div>}
          {!!description && (
            <div>
              {t(description, { ...translateValues })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

InfoBox.propTypes = {
  translate: PropTypes.string,
  icon: PropTypes.any,
  translateValues: PropTypes.object,
  renderTitle: PropTypes.func,
  hideIcon: PropTypes.bool,
  className: PropTypes.string,
  textClassName: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  action: PropTypes.any,
};

InfoBox.defaultProps = {
  translate: 'admin',
  translateValues: {},
  hideIcon: true
};

export default memo(InfoBox);
